import { Point2D, ProductionComponentInstance, ProductionComponentInstanceStatus } from '@paragon/contract-library';

import { DesignService } from '../connections';

export function getForProductionGroup(productionGroupGuid: string): Promise<readonly ProductionComponentInstance[]> {
  return DesignService.get(`public/productionComponentInstances/forProductionGroup/${productionGroupGuid}`);
}

export function insert(productionComponentInstances: readonly ProductionComponentInstance[]): Promise<void> {
  return DesignService.post('public/productionComponentInstances/bulkInsert', { data: productionComponentInstances });
}

export function patchAppendToBundle(
  instancePositions: { [productionComponentInstanceGuid: string]: Point2D },
  bundleGuid: string,
): Promise<readonly ProductionComponentInstance[]> {
  return DesignService.patch('public/productionComponentInstances/appendToBundle', {
    data: { bundleGuid, instancePositions },
  });
}

export function patchRemoveFromBundle(
  productionComponentInstanceGuids: readonly string[],
): Promise<readonly ProductionComponentInstance[]> {
  return DesignService.patch('public/productionComponentInstances/removeFromBundle', {
    data: productionComponentInstanceGuids,
  });
}

export function patchAddToBatch(
  productionComponentInstanceGuids: readonly string[],
  batchGuid: string,
): Promise<ProductionComponentInstance[]> {
  return DesignService.patch('public/productionComponentInstances/addToBatch', {
    data: { batchGuid, productionComponentInstanceGuids },
  });
}

export function patchRemoveFromBatch(
  productionComponentInstanceGuids: string[],
): Promise<readonly ProductionComponentInstance[]> {
  return DesignService.patch('public/productionComponentInstances/removeFromBatch', {
    data: productionComponentInstanceGuids,
  });
}

export function updateAnalysisSetGuids(productionComponentInstanceGuidToUpdatedAnalysisSetGuid: {
  [productionComponentInstanceGuid: string]: string;
}): Promise<readonly ProductionComponentInstance[]> {
  return DesignService.patch('public/productionComponentInstances/updateAnalysisSetGuids', {
    data: productionComponentInstanceGuidToUpdatedAnalysisSetGuid,
  });
}

export function setStatus(
  productionComponentInstanceGuids: readonly string[],
  status: ProductionComponentInstanceStatus,
): Promise<void> {
  return DesignService.patch('public/productionComponentInstances/setStatus', {
    data: { productionComponentInstanceGuids, status },
  });
}

export function bulkDelete(productionComponentInstanceGuids: readonly string[]): Promise<void> {
  return DesignService.delete('public/productionComponentInstances/bulkDelete', {
    data: productionComponentInstanceGuids,
  });
}

export function setBundlePositions(updatedPositions: {
  [productionComponentInstanceGuid: string]: Point2D;
}): Promise<readonly ProductionComponentInstance[]> {
  return DesignService.patch('public/productionComponentInstances/setBundlePositions', { data: updatedPositions });
}
